import React, { useState, useRef, useCallback, useEffect } from "react";
import classnames from "classnames";
import styles from "@/styles/ExpandText.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ExpandText = _ref => {
  let {
    className,
    children,
    onClick
  } = _ref;
  const {
    0: more,
    1: setMore
  } = useState(false);
  const {
    0: open,
    1: setOpen
  } = useState();
  const containerRef = useRef();
  const textRef = useRef();
  const toggle = useCallback(() => {
    setOpen(!open);
    if (typeof onClick == "function") {
      onClick();
    }
  }, [open]);
  useEffect(() => {
    if (typeof open === "undefined") {
      const containerHeight = containerRef.current.clientHeight;
      const textHeight = textRef.current.clientHeight;
      if (containerHeight < textHeight) {
        setMore(true);
      } else {
        setMore(false);
      }
      setOpen(false);
    }
  }, [open, containerRef.current, textRef.current]);
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles["expand-text"], {
      [styles.open]: open === true,
      [styles.withMore]: more
    }, className),
    ref: containerRef,
    children: [/*#__PURE__*/_jsx("div", {
      ref: textRef,
      children: React.Children.map(children, (child, i) => /*#__PURE__*/React.cloneElement(child, {
        className: classnames({
          [styles.firstNode]: i == 0,
          [styles.ellipsis]: open === false && i == 0,
          [styles.otherNode]: i > 0
        })
      }))
    }), more && /*#__PURE__*/_jsx("div", {
      className: classnames(styles.showMoreBtn, {
        [styles.open]: open === true
      }),
      children: /*#__PURE__*/_jsx("button", {
        onClick: toggle,
        children: open === true ? "元に戻す" : "もっと詳しく"
      })
    })]
  });
};
export default ExpandText;